import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import "../styles/login.css";
import { useHistory, Link } from "react-router-dom";
import { TopNotification } from "./Notification";

function Login() {
  const { login, currentUser, globalNotification, setGlobalNot } = useAuth();
  const [loading, setLoading] = useState(false);
  const usernameRef = useRef();
  const passwordRef = useRef();
  const history = useHistory();
  const [error, setError] = useState();

  useEffect(() => {
    if (currentUser) {
      history.push("/account");
    }
  }, [currentUser]);

  async function signIn(e) {
    e.preventDefault();

    try {
      setLoading(true);
      const result = login(
        usernameRef.current.value,
        passwordRef.current.value
      ).then((response) => {
        if (
          response !== "hatalı giriş" &&
          response !== "hesap etkinleştirilmemiş"
        ) {
          history.push("/account");
        } else {
          clearInput();
          setError(response);
          setGlobalNot(response);
        }
      });
    } catch {
      console.log("Failed to sign up");
    }
    setLoading(false);
  }

  const clearInput = () => {
    usernameRef.current.value = "";
    passwordRef.current.value = "";
  };

  return (
    <div className="login">
      <div className="login__container">
        <form onSubmit={signIn} className="login__form">
          <h1>GIRIS YAP</h1>
          {globalNotification && (
            <TopNotification
              notification={globalNotification}
              color={"green"}
            />
          )}
          {error && <TopNotification notification={error} color={"red"} />}
          <div className="h5">
            <h5>KULLANICI ADI</h5>
          </div>
          <div className="input">
            <input type="text" ref={usernameRef} required />
          </div>
          <div className="h5">
            <h5>SIFRE</h5>
          </div>
          <div className="input">
            <input type="password" ref={passwordRef} required />
          </div>
          <Link to="/register" className="login__formRecoverPassword">
            KAYIT OL
          </Link>
          <Link to="/recoverAccount" className="login__formRecoverPassword">
            SIFREMI UNUTTUM
          </Link>
          <div className="register__buttons">
            <div className="button">
              <button
                disabled={loading}
                type="submit"
                className="login__signInButton"
              >
                GIRIS YAP
              </button>
            </div>
          </div>

          <div className="topLeftBorder">
            <div>
              <div className="borderTop"></div>
              <div className="borderLeft"></div>
            </div>
          </div>
          <div className="bottomRigtBorder">
            <div>
              <div className="borderRight"></div>
              <div className="borderBottom"></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
